import api from "./api";

export const putTreatment = (data: any) => {
  return api.put("/Treatment", data);
};
